export enum StripeSubscriptionStatus {
  ACTIVE = 'active',
  NOT_SETUP = 'not_setup',
  INACTIVE = 'inactive',
}

type StoreItem = {
  id: number
  editable_client_id: number | null
  feed_name: string
  status: number
  config:
    | {
        hide?: string[]
      }
    | []
  logo_url: string
  stripe_subscription_status: StripeSubscriptionStatus
  payment_type: string
}

export type AdvertiserItem = {
  id: number
  name: string
  status?: number
  config:
    | {
        hide?: string[]
      }
    | []
  logoUrl: string
  stripeSubscriptionStatus?: StripeSubscriptionStatus
  paymentType: string
}

type CurrencyServerType = {
  code: string
  name: string
  symbol: string
  subunit: string
  is_before: number
  ratio_to_eur: number
}

export type UserServerType = {
  id: number
  username: string
  email: string
  phone: string
  created_at: string
  updated_at: string
  admin: number
  last_active: string
  first_name: string
  surname: string
  vat_no: string
  country: string
  city: string
  address: string
  postcode: string
  config: string
  sign_user_agreement: string
  revenue_tier_id: number
  recruitment_utm: string | null
  payment_blocked: number
  tier_pricing_type: string
  td_account_id: number | null
  stores: StoreItem[]
  currencyObj: CurrencyServerType
  lang: string
  own_paymentsystem: number
  locale: string
  store_group_id: number
  is_suspended: boolean
  is_verified: boolean
  subscriber: {
    id: string
    hash: string
  }
}

export type CurrencyType = {
  code: string
  name: string
  symbol: string
  subunit: string
  isBefore: number
  ratioToEur: number
}

export type UserType = {
  id: number
  username: string
  email: string
  phone: string
  createdAt: string
  updatedAt: string
  admin: number
  lastActive: string
  firstName: string
  surname: string
  vatNo: string
  country: string
  city: string
  address: string
  postcode: string
  config: string
  signUserAgreement: string
  revenueTierId: number
  recruitmentUtm: string | null
  paymentBlocked: number
  tierPricingType: string
  tdAccountId: number | null
  advertisers: AdvertiserItem[]
  currencyObj: CurrencyType
  lang: string
  ownPaymentsystem: number
  locale: string
  storeGroupId: number
  isSuspended: boolean
  isVerified: boolean
  subscriber: {
    id: string
    hash: string
  }
}
